import { render, staticRenderFns } from "./SemesterNames.vue?vue&type=template&id=6627ee15&"
import script from "./SemesterNames.vue?vue&type=script&lang=ts&"
export * from "./SemesterNames.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports